import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Query } from 'react-apollo';

import queries from '../../graphql/queries';

import PageTitle from '../../components/shared/page-title';
import ProfileHeader from '../../components/profile/header';
import ProfileFeeds from '../../components/profile/feeds';
import ProfileCredentials from '../../components/profile/credentials';
import ProfileTopics from '../../components/profile/topics';
import AnswerList from '../../components/profile/answer-list';
import QuestionList from '../../components/profile/question-list';
import PostList from '../../components/profile/post-list';
import Followers from '../../components/profile/follows/follower-list';
import Following from '../../components/profile/follows/following-list';

import style from './index.module.scss';

const {
  userQueries: { USER_BY_ID },
} = queries;

function ProfilePage(props) {
  const {
    match: {
      params: { fullname },
    },
    location: {
      state: { userId },
    },
  } = props;

  return (
    <>
      <PageTitle
        pageTitle={`Quora - ${fullname}`}
        pageDesc="Profile page of Quora"
      />
      <Query query={USER_BY_ID} variables={{ userId }}>
        {({ loading, error, data }) => {
          if (loading) return <div>Loading...</div>;
          if (error) return <div>Error!</div>;

          const { userById } = data;

          return (
            <div className={`row ${style.profile}`}>
              <main className={`col-md-12 col-lg-9 ${style['profile-main']}`}>
                <ProfileHeader user={userById} />
                <div className={`row ${style['profile-credentials-mobile']}`}>
                  <ProfileCredentials credentials={userById.credentials} />
                </div>
                <section className={`row ${style['row--main']}`}>
                  <div className={`col ${style['col--feeds']}`}>
                    <ProfileFeeds user={userById} />
                  </div>
                  <div className={`col ${style['col--main-content']}`}>
                    <Switch>
                      <Route
                        path={`/account/${fullname}`}
                        exact
                        component={() => (
                          <AnswerList answerList={userById.addedAnswers} />
                        )}
                      />
                      <Route
                        path={`/account/${fullname}/questions`}
                        component={() => (
                          <QuestionList
                            questionList={userById.addedQuestions}
                          />
                        )}
                      />
                      <Route
                        path={`/account/${fullname}/blogs`}
                        component={() => (
                          <PostList postList={userById.addedBlogPosts} />
                        )}
                      />
                      <Route
                        path={`/account/${fullname}/followers`}
                        component={() => (
                          <Followers followerList={userById.followers} />
                        )}
                      />
                      <Route
                        path={`/account/${fullname}/following`}
                        component={() => (
                          <Following followingList={userById.following} />
                        )}
                      />
                    </Switch>
                  </div>
                </section>
              </main>
              <aside className={`col-lg-3 ${style['profile-aside']}`}>
                <ProfileCredentials credentials={userById.credentials} />
                <ProfileTopics />
              </aside>
            </div>
          );
        }}
      </Query>
    </>
  );
}

export default ProfilePage;
